export default __webpack_public_path__ + "static/media/banner5.67ec5262.jpg";